import React, { useEffect, useState } from "react";
import { Alert, Empty, Modal, Table } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { translate } from "../../locale";
import SubscriptionServices from "../../services/SubscriptionServices";
import { TableHelper } from "../../helpers/TableHelper";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const ModalLinkHistory = ({ visible, subscription, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const columns = [
    {
      title: translate("Hora"),
      dataIndex: "time",
      key: "time",
    },
    {
      title: translate("Fecha"),
      dataIndex: "date",
      key: "date",
    },
    {
      title: translate("Link"),
      dataIndex: "url",
      key: "url",
    },
    {
      title: translate("Responsable de edición"),
      dataIndex: "full_name",
      key: "full_name",
    },
  ];

  useEffect(() => {
    console.log("subscription", subscription);
  }, []);

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
      if (visible === true) {
        loadData();
      }
    }
  }, [visible]);

  useEffect(() => {
    let data = {
      page_size: tableParams.pagination.pageSize,
      page_num: tableParams.pagination.current,
    };
    const sorter = TableHelper.sorter(tableParams);
    if (sorter !== null) {
      data = { ...data, order_by: sorter };
    }
    loadData(data);
  }, [JSON.stringify(tableParams)]);

  const loadData = async () => {
    try {
      const response = await SubscriptionServices.getExternalLink(
        subscription.enterprise_id,
        subscription.id
      );

      if (
        response.status >= 200 &&
        response.status < 300 &&
        response.data.data[0] != undefined
      ) {
        const newData = response.data.data[0].history.map((i) => ({
          ...i,
          full_name: `${i.first_name} ${i.last_name}`,
        }));
        setData(newData);
        setFilteredData(newData);
        // setTotal(response.data.data[0].total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <Modal
      open={active}
      title={translate("Registro de modificaciones")}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
      width={"80%"}
    >
      {error && (
        <Alert
          message={error}
          type="error"
          className="mb-6"
          closable
          onClose={() => setError("")}
        />
      )}
      <Table
        dataSource={filteredData}
        columns={columns}
        loading={
          loading && { indicator: antIcon, className: "text-custom_blue" }
        }
        rowKey={(i) => i.id}
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        // pagination={{ ...tableParams.pagination, total: total }}
        // onChange={handleTableChange}
      />
    </Modal>
  );
};

export default ModalLinkHistory;
